export default function Warranty() {
  return (
    <div className="min-h-screen bg-black py-16 px-4" dir="rtl">
      <div className="max-w-4xl mx-auto text-white">
        <h1 className="text-4xl font-black mb-8">الضمان</h1>
        <div className="space-y-6 text-neutral-300 leading-loose text-lg">
          <p>
            نقدم في برولاكس ضماناً شاملاً لمدة <strong className="text-red-500">5 سنوات</strong> على جميع
            أجهزتنا الكهربائية، ابتداءً من تاريخ الشراء. يشمل هذا الضمان عيوب التصنيع والمواد
            التي تؤثر على أداء الجهاز.
          </p>
          <p>
            لا يشمل الضمان الأضرار الناتجة عن سوء الاستخدام، التخزين غير المناسب، أو التعديلات
            غير المصرح بها. كما لا يغطي الأجزاء الاستهلاكية الطبيعية مثل الفلاتر أو الشفرات
            القابلة للتلف.
          </p>
          <p>
            في حال وجود عطل مشمول بالضمان، يُرجى التواصل مع فريق دعم العملاء عبر الهاتف أو
            البريد الإلكتروني. سنقوم بإصلاح الجهاز أو استبداله مجاناً خلال فترة الضمان.
          </p>
          <p>
            للاستفادة من خدمة الضمان، يجب تقديم فاتورة الشراء أو رقم الطلب كدليل على تاريخ
            الشراء.
          </p>
        </div>
      </div>
    </div>
  );
}